import { generatePath } from 'react-router-dom';

import { PaymentIntent } from 'types';

import { URL } from '../constants';
import { apiInstance } from '../instance';

import {
  VerifyManagerPin,
  GetPaymentStatus,
  CheckDuplicateCard,
  DuplicateCardCheck,
  CheckReaderStatus,
  ReaderStatusAnswer,
} from './types';

export const getPaymentStatus = ({ intentId, signal }: GetPaymentStatus) =>
  apiInstance.get<PaymentIntent>(
    generatePath(URL.CLOVER_PAYMENT_STATUS, { intentId: String(intentId) }),
    { timeout: 12_000, signal }
  );

// DOUBLE-CHARGE GUARD (owner 19 Oct 2026): read-only, asked before Credit. A
// short timeout: the screen fails open, so a slow answer never holds a sale.
export const DUPLICATE_CARD_CHECK_TIMEOUT_MS = 3_000;

export const checkDuplicateCard = ({
  signal,
  eventId,
  amountCents,
}: CheckDuplicateCard) =>
  apiInstance.get<DuplicateCardCheck>(
    generatePath(URL.CART_DUPLICATE_CARD_CHECK, { id: String(eventId) }),
    {
      signal,
      params: { amountCents },
      timeout: DUPLICATE_CARD_CHECK_TIMEOUT_MS,
    }
  );

// OFFLINE READER GUARD (owner 22 Oct 2026): a live, read-only status of the
// chosen reader, asked right before a NEW card request. The server never asks
// Clover while a sale holds that reader (it answers "In a sale" from its own
// data) and waits at most 5 s for Clover. The screen fails open.
export const READER_CHECK_TIMEOUT_MS = 6_000;

export const checkReaderStatus = ({ signal, deviceId }: CheckReaderStatus) =>
  apiInstance.get<ReaderStatusAnswer>(
    generatePath(URL.CLOVER_READER_STATUS_DEVICE, { deviceId: String(deviceId) }),
    {
      signal,
      params: { fresh: 1 },
      timeout: READER_CHECK_TIMEOUT_MS,
      headers: { 'allow-not-found': 'true' },
    }
  );

// The event leader's Manager PIN, through the existing check (the same one the
// exchange flow uses; attempts are limited on the server).
export const verifyManagerPin = ({
  leaderId,
  approvalPassword,
}: VerifyManagerPin) =>
  apiInstance.post<{ isPasswordValid: boolean }>(
    generatePath(URL.USER_VERIFY_APPROVAL_PASSWORD, { id: String(leaderId) }),
    { approvalPassword }
  );
